import React, { useEffect, useState, lazy, createElement } from 'react';
import { TopBanner } from './components/TopBanner';
import { NavBar } from './components/NavBar';
import { PopNotification } from './components/PopNotification';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ForYourBabySection } from './components/ForYourBabySection';
import { SolutionSection } from './components/SolutionSection';
import { ProductSection } from './components/ProductSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueStackSection } from './components/ValueStackSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { ShareSection } from './components/ShareSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { Modal } from './components/Modal';
import { UpsellPopup } from './components/UpsellPopup';
import { PrivacyPolicyContent, TermsOfServiceContent, DisclaimerContent } from './components/ModalContent';
type ModalType = 'privacy' | 'terms' | 'disclaimer' | null;
export function App() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  const [showUpsell, setShowUpsell] = useState(false);
  // Set lang attribute and meta viewport
  useEffect(() => {
    document.documentElement.lang = 'es';
    document.documentElement.dir = 'ltr';
    // Ensure meta viewport exists for mobile
    if (!document.querySelector('meta[name="viewport"]')) {
      const meta = document.createElement('meta');
      meta.name = 'viewport';
      meta.content = 'width=device-width, initial-scale=1';
      document.head.appendChild(meta);
    }
    // Add meta description for SEO
    if (!document.querySelector('meta[name="description"]')) {
      const desc = document.createElement('meta');
      desc.name = 'description';
      desc.content = 'Protocolo B.E.BE 365 — El primer protocolo de neuro-arquitectura infantil que unifica sueño, estimulación cognitiva y nutrición para el primer año de tu bebé.';
      document.head.appendChild(desc);
    }
    // Set page title
    document.title = 'Protocolo B.E.BE 365 — El Primer Año de tu Bebé';
  }, []);
  useEffect(() => {
    // Facebook Pixel
    const pixelId = '1466073988306169';
    const f = window as any;
    if (!f.fbq) {
      const n = (f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    f.fbq('init', pixelId);
    f.fbq('track', 'PageView');
    f.fbq('track', 'ViewContent', {
      content_name: 'Protocolo B.E.BE 365',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
    // Add noscript fallback pixel
    if (!document.querySelector('img[data-fb-noscript]')) {
      const noscriptImg = document.createElement('img');
      noscriptImg.height = 1;
      noscriptImg.width = 1;
      noscriptImg.style.display = 'none';
      noscriptImg.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
      noscriptImg.setAttribute('data-fb-noscript', 'true');
      document.body.appendChild(noscriptImg);
    }
  }, []);
  // Performance optimizations
  useEffect(() => {
    // A. Preconnect to CDNs and payment gateways
    const preconnects = ['https://cdn.shopify.com', 'https://cdn.magicpatterns.com', 'https://js.stripe.com', 'https://www.paypal.com'];
    preconnects.forEach(url => {
      if (!document.querySelector(`link[rel="preconnect"][href="${url}"]`)) {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = url;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      }
    });
    // B. Lazy load videos via IntersectionObserver
    const videoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target as HTMLVideoElement;
          video.preload = 'auto';
          video.play().catch(() => {
            /* Autoplay policy handling */
          });
          observer.unobserve(video);
        }
      });
    }, {
      rootMargin: '300px'
    });
    document.querySelectorAll('video').forEach(vid => {
      vid.preload = 'none';
      videoObserver.observe(vid);
    });
    return () => {
      videoObserver.disconnect();
    };
  }, []);
  const handleOpenModal = (modalId: ModalType) => {
    setOpenModal(modalId);
  };
  const handleCloseModal = () => {
    setOpenModal(null);
  };
  const handleScrollToBonuses = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.querySelector('#bonuses');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  const handleCheckoutClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowUpsell(true);
  };
  return <div className="w-full min-h-screen" data-id="element-0">
      {/* Skip to content link for keyboard users */}
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-[99999] focus:bg-white focus:text-[#3D2B1F] focus:px-4 focus:py-2 focus:text-sm focus:font-bold" data-id="element-1">
        Saltar al contenido principal
      </a>

      <TopBanner data-id="element-2" />
      <NavBar onBuyClick={handleScrollToBonuses} data-id="element-3" />
      <PopNotification data-id="element-4" />

      <main id="main-content" data-id="element-5">
        <HeroSection onBuyClick={handleScrollToBonuses} data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <ForYourBabySection data-id="element-8" />
        <ProductSection onBuyClick={handleScrollToBonuses} data-id="element-9" />
        <BonusesSection onBuyClick={handleCheckoutClick} data-id="element-10" />
        <PainSection data-id="element-11" />
        <SolutionSection data-id="element-12" />
        <ValueStackSection onBuyClick={handleScrollToBonuses} data-id="element-13" />
        <GuaranteeSection onBuyClick={handleScrollToBonuses} data-id="element-14" />
        <FAQSection data-id="element-15" />
        <ShareSection data-id="element-16" />
        <FinalCTASection data-id="element-17" />
      </main>

      <Footer onOpenModal={handleOpenModal} data-id="element-18" />

      <UpsellPopup isOpen={showUpsell} onClose={() => setShowUpsell(false)} data-id="element-19" />

      <Modal isOpen={openModal === 'privacy'} onClose={handleCloseModal} title="Política de Privacidad" data-id="element-20">
        <PrivacyPolicyContent data-id="element-21" />
      </Modal>

      <Modal isOpen={openModal === 'terms'} onClose={handleCloseModal} title="Términos de Servicio" data-id="element-22">
        <TermsOfServiceContent data-id="element-23" />
      </Modal>

      <Modal isOpen={openModal === 'disclaimer'} onClose={handleCloseModal} title="Descargo de Responsabilidad" data-id="element-24">
        <DisclaimerContent data-id="element-25" />
      </Modal>
    </div>;
}